module.exports = __webpack_public_path__ + "img/tp11.405ab364.png";